// extracted by mini-css-extract-plugin
export default {"container":"style_container__kI+h-","spinner":"style_spinner__qpOLQ","spin":"style_spin__YGOTH"};